import React from 'react';
import { RefreshCw, FileText, ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const EtudiantPageHeader = ({ 
  onRefresh, 
  onExport, 
  isExporting 
}) => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-r from-[#202654] to-[#202654]/90 px-6 py-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between">
        <div className="flex items-center text-white">
          <button
            onClick={() => navigate(-1)}
            className="mr-4 p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-all duration-200 backdrop-blur-sm"
          >
            <ChevronLeft className="h-5 w-5" />
          </button>
          <div>
            <h1 className="text-2xl font-bold">Gestion des Étudiants</h1>
            <p className="mt-1 text-blue-100">
              Gérez et visualisez tous les étudiants de l'établissement
            </p>
          </div>
        </div>
        
        <div className="mt-4 md:mt-0 flex flex-col sm:flex-row sm:space-x-3 space-y-3 sm:space-y-0">
          <button
            onClick={onRefresh}
            className="inline-flex items-center justify-center px-4 py-2 border border-white/20 rounded-md shadow-sm text-sm font-medium text-white bg-white/10 hover:bg-white/20 backdrop-blur-sm transition-all duration-200"
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Actualiser
          </button>
          
          {/* Menu d'export */}
          <div className="relative group">
            <button
              disabled={isExporting}
              className="inline-flex items-center justify-center px-4 py-2 border border-white/20 rounded-md shadow-sm text-sm font-medium text-white bg-white/10 hover:bg-white/20 backdrop-blur-sm transition-all duration-200 disabled:opacity-50"
            >
              <FileText className="h-4 w-4 mr-2" />
              {isExporting ? 'Export...' : 'Exporter'}
            </button>
            
            {/* Dropdown menu */}
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-10">
              <div className="py-1">
                <button
                  onClick={() => onExport('excel')}
                  disabled={isExporting}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50"
                >
                  📊 Excel (.xlsx)
                </button>
                <button
                  onClick={() => onExport('csv')}
                  disabled={isExporting}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50"
                >
                  📄 CSV (.csv)
                </button>
                <button
                  onClick={() => onExport('pdf')}
                  disabled={isExporting}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50"
                >
                  📑 PDF (.pdf)
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EtudiantPageHeader;
